var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-block"},[_c('div',[_c(_vm.getUserLinks,{tag:"component"})],1),_c('AddChildModal',{attrs:{"id":"NewChildModal"}}),_c('NewServiceModal',{attrs:{"id":"newServiceModal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }